import * as React from 'react';
import { ArticleHeading4, Responsive } from '@cian/ui-kit';

import * as style from './styles.css';

export interface ICommentProps {
  title?: string;
  children: React.ReactNode;
  isQuestion?: boolean;
}

export const Comment: React.FC<ICommentProps> = ({ title, children }) => {
  return (
    <div data-testid="Comment" className={style['container']}>
      <Responsive desktop>
        {!!title && (
          <div className={style['title']}>
            <ArticleHeading4>{title}</ArticleHeading4>
          </div>
        )}
      </Responsive>
      <Responsive tablet phone>
        {!!title && <div className={style['title']}>{<ArticleHeading4>{title}</ArticleHeading4>}</div>}
      </Responsive>
      <div className={style['message']}>{children}</div>
    </div>
  );
};
